import styled from 'styled-components';
import { motion } from 'motion/react';
import { media } from '@/styles/breakpoints';

export const CardLink = styled(motion.a)`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.radii.lg};
  border: 1px solid ${({ theme }) => theme.semantic.border.subtle};
  background: ${({ theme }) => theme.semantic.background.primary};
  overflow: hidden;
  cursor: pointer;
  transition:
    border-color 0.3s ease,
    box-shadow 0.3s ease;
  height: 500px;
  width: 100%;

  &:hover {
    border-color: ${({ theme }) => theme.colors.cyan[400]}44;
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  ${media.tablet} {
    width: 380px;
  }
`;

export const CardImage = styled(motion.div)<{ $src: string }>`
  width: 100%;
  height: 220px;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => theme.spacing[6]};
  flex: 1;
`;

export const CardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
`;

export const CardDate = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacings.wider};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.cyan[400]};
`;

export const CardSource = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.semantic.text.muted};
`;

export const CardTitle = styled(motion.h3)`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.semantic.text.primary};
  line-height: ${({ theme }) => theme.lineHeights.snug};

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardSummary = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.semantic.text.tertiary};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.spacing[3]};
  border-top: 1px solid ${({ theme }) => theme.semantic.border.subtle};
  margin-top: auto;
`;

export const CardReadMore = styled(motion.span)`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.cyan[400]};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]};
`;
